export default "__VITE_ASSET__DzT8jGpd__"